/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { TextProps, TextElement } from '../../types';
import './Text.less';

/**
 * Default HTML element per variant.
 * Headers get their semantic heading tag; body text defaults to <span>.
 */
const defaultElement: Record<string, TextElement> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  b1: 'span',
  b2: 'span',
  c1: 'code',
  c2: 'code',
};

const Text = React.forwardRef<HTMLElement, TextProps>(
  (
    {
      variant = 'b1',
      weight = 'regular',
      color = 'primary',
      as,
      noWrap = false,
      truncate = false,
      className,
      style,
      children,
    },
    ref
  ) => {
    const Element = as || defaultElement[variant] || 'span';

    return React.createElement(
      Element,
      {
        ref,
        className: cx(
          'text',
          `text--${variant}`,
          `text--${weight}`,
          `text--color-${color}`,
          {
            'text--no-wrap': noWrap && !truncate,
            'text--truncate': truncate,
          },
          className
        ),
        style,
      },
      children
    );
  }
);

Text.displayName = 'Text';

export default Text;
